export default "__VITE_ASSET__DcMaDY_5__"